import api from '~/services/api';

function getAuthorizedApps() {
  return api.request({
    url: '/ui/oauth/authorized_client_apps',
    method: 'GET',
  });
}

// It is optional in usage. Should it be?
function deleteAuthorizedApps(id?: string) {
  return api.request({
    url: `/ui/oauth/authorized_client_apps/${id}`,
    method: 'DELETE',
  });
}
export { getAuthorizedApps, deleteAuthorizedApps };
